import React from 'react'
import * as yup from 'yup'
import { Divider } from '../../../../components/divider'
import { dateYupOptional } from '../../../../validators'
import {
  addressLengthMessage,
  cityLengthMessage,
  zipMessage,
  zipLengthMessage
} from '../../../../strings/messages'
import { zipRegex } from '../../../../strings/regex'

export const lastKnownLocation = {
  id: 'last_known_location',
  title: `What is the fugitive's last known location?`,
  description:
    'If you do not know the exact address, enter an approximate address to the best of your ability. You will have an option to enter a more general description of the location on a later screen.',
  validation: yup.object().shape({
    location_address: yup.object().shape({
      line1Value: yup.string().max(50, addressLengthMessage),
      line2Value: yup.string().max(50, addressLengthMessage),
      cityValue: yup.string().max(30, cityLengthMessage),
      zipValue: yup
        .string()
        .max(10, zipLengthMessage)
        .test('zipcode_required', zipMessage, function(value) {
          const { countryValue } = this.parent
          return countryValue === 'US'
            ? value === '' || zipRegex.test(value)
            : true
        })
    }),
    location_date: dateYupOptional()
  }),
  fields: [
    {
      type: 'address',
      name: 'location_address',
      label: 'Last known location',
      countryValue: 'US'
    },
    {
      type: 'content',
      component: Divider
    },
    {
      type: 'content',
      component: () => (
        <React.Fragment>
          <h2>When was the fugitive last known to be at the location?</h2>
          <p>
            If you cannot remember the exact date, please enter the approximate
            date.
          </p>
        </React.Fragment>
      )
    },
    {
      type: 'date',
      name: 'location_date',
      label: 'Date at location',
      hint: 'For example: 7 / 14 / 2018'
    }
  ]
}
